import React, { useState } from 'react';
import { Check, Pencil, Smartphone, X } from 'lucide-react';
import { getScannerName, setScannerName, SCANNER_NAME_MAX } from '../utils/scannerName';

/** Shows and edits this device's optional scanner label; saved on the device only. */
const ScannerNameChip = ({ className = '' }) => {
  const [name, setName] = useState(getScannerName);
  const [draft, setDraft] = useState(null);

  const save = () => {
    setName(setScannerName(draft));
    setDraft(null);
  };

  if (draft !== null) {
    return (
      <form
        className={`flex items-center gap-1 ${className}`}
        onSubmit={(e) => { e.preventDefault(); save(); }}
      >
        <input
          autoFocus
          value={draft}
          maxLength={SCANNER_NAME_MAX}
          onChange={(e) => setDraft(e.target.value)}
          placeholder="e.g. Gate 2 or your name"
          className="h-8 w-44 rounded-md border border-gray-300 px-2 text-sm"
          aria-label="Scanner name"
        />
        <button type="submit" className="rounded p-1 text-green-700 hover:bg-green-50" aria-label="Save scanner name">
          <Check className="h-4 w-4" />
        </button>
        <button type="button" onClick={() => setDraft(null)} className="rounded p-1 text-gray-500 hover:bg-gray-100" aria-label="Cancel">
          <X className="h-4 w-4" />
        </button>
      </form>
    );
  }

  return (
    <button
      type="button"
      onClick={() => setDraft(name)}
      className={`inline-flex items-center gap-1.5 rounded-full border border-gray-200 bg-white px-3 py-1 text-xs text-gray-600 hover:bg-gray-50 ${className}`}
      title="Name this device so scans show who recorded them. Saved on this device only."
    >
      <Smartphone className="h-3.5 w-3.5" />
      {name ? <>Scanner: <span className="font-medium text-gray-900">{name}</span></> : 'Set scanner name (optional)'}
      <Pencil className="h-3 w-3" />
    </button>
  );
};

export default ScannerNameChip;
